import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService, GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { ContactRequest } from '@interfaces';
import { AppService, BaseEngagementService } from '../../../../services';
import { getSetup } from './grid/get-setup';

@Component({
	selector: 'common-contact-request-grid',
	standalone: true,
	imports: [GridContentWidget],
	templateUrl: './contact-request-grid.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./contact-request-grid.part.scss'],
})
export class CommonContactRequestGridPart {

	public pageService = input.required<BaseEngagementService>();
	public data = input.required<ContactRequest[]>();
	private readonly dialogService = inject(DialogService);
	private readonly util = inject(UtilityService);
	private readonly app = inject(AppService);

	public setup = computed(() => {
		return getSetup(this.pageService(), this.util, this.dialogService, this.app);
	});

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		const service = this.pageService();
		const layout = service.layout();
		if (layout) {
			return { layout: layout, viewSelector: true };
		}
		return undefined;
	});


}
